import api from "./api";

export default {
  async login({ email, password }) {
    const response = await api.post("/api/auth/login/", { email, password });
    return response.data;
  },

  async refreshToken(refresh) {
    const response = await api.post("/api/auth/token/refresh/", { refresh });
    return response.data;
  },

  async whoami() {
    const response = await api.get("/api/auth/user/");
    return response.data;
  },

  async changeUserDetails({ first_name, last_name }) {
    const response = await api.patch("/api/auth/user/", {
      first_name,
      last_name
    });
    return response.data;
  },

  async changePassword({ old_password, new_password1, new_password2 }) {
    const response = await api.post("/api/auth/password/change/", {
      old_password,
      new_password1,
      new_password2
    });
    return response.data;
  },

  async requestResetPassword({ email }) {
    const response = await api.post("/api/auth/password/reset/", { email });
    return response.data;
  },

  async resetPassword({ new_password1, new_password2, uid, token }) {
    const response = await api.post("/api/auth/password/reset/confirm/", {
      new_password1,
      new_password2,
      uid,
      token
    });
    return response.data;
  },

  async register({ email, password1, password2, first_name, last_name }) {
    const response = await api.post("/api/auth/registration/", {
      email,
      password1,
      password2,
      first_name,
      last_name
    });
    return response.data;
  },

  async verifyEmail(key) {
    const response = await api.post("/api/auth/registration/verify-email/", {
      key
    });
    return response.data;
  }
};
